import React, { useState } from 'react';
import { MessageSquare, ChevronLeft, ChevronRight } from 'lucide-react';
import { EARTH } from '../theme/constants';

export function CommentsPanel({ isOpen, onToggle, comments, onAddComment }) {
  const [newComment, setNewComment] = useState('');

  const handleAdd = () => {
    if (newComment.trim()) {
      onAddComment(newComment);
      setNewComment('');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed right-0 top-0 h-full w-72 shadow-xl z-20 flex flex-col" style={{ backgroundColor: '#fff', borderLeft: '1px solid ' + EARTH.stone[200] }}>
      <div className="flex items-center justify-between p-4 border-b" style={{ borderColor: EARTH.stone[200], backgroundColor: EARTH.sand[50] }}>
        <div className="flex items-center gap-2">
          <MessageSquare className="w-5 h-5" style={{ color: EARTH.sand[600] }} />
          <h3 className="font-semibold" style={{ color: EARTH.sand[800] }}>Comments</h3>
          {comments.length > 0 && (
            <span className="text-xs px-2 py-0.5 rounded-full" style={{ backgroundColor: EARTH.sand[200], color: EARTH.sand[700] }}>{comments.length}</span>
          )}
        </div>
        <button onClick={onToggle} className="p-1 rounded" style={{ color: EARTH.stone[500] }}>
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-4">
        {comments.length === 0 ? (
          <p className="text-sm text-center py-8" style={{ color: EARTH.stone[400] }}>No comments yet</p>
        ) : (
          <div className="space-y-3">
            {comments.map(c => (
              <div key={c.id} className="p-3 rounded-xl" style={{ backgroundColor: EARTH.sand[50] }}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-medium" style={{ color: EARTH.stone[700] }}>{c.user}</span>
                  <span className="text-xs" style={{ color: EARTH.stone[400] }}>{c.timestamp}</span>
                </div>
                <p className="text-sm" style={{ color: EARTH.stone[600] }}>{c.text}</p>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="p-4 border-t" style={{ borderColor: EARTH.stone[200] }}>
        <div className="flex gap-2">
          <input
            type="text"
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
            placeholder="Add a comment..."
            className="flex-1 px-3 py-2 text-sm rounded-xl"
            style={{ border: '1px solid ' + EARTH.stone[200] }}
          />
          <button onClick={handleAdd} className="px-4 py-2 rounded-xl" style={{ backgroundColor: EARTH.sand[600], color: '#fff' }}>
            <MessageSquare className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
